import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminPage, Pill } from "@/pages/admin/AdminLayout";

export default function SourcesAdmin() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/sources").then((r) => setRows(r.data));
  }, []);

  const unverified = rows.filter((r) => !r.last_verified).length;

  return (
    <AdminPage
      title="Sources & verification"
      lede={`${rows.length} source records across all articles — ${unverified} not yet verified. Prices, dimensions, electrical requirements, warranties and manufacturer specifications must carry a verified source before they can be published as fact.`}
    >
      <div className="bg-white border border-line overflow-x-auto" data-testid="admin-sources-table">
        <table className="w-full min-w-[900px] text-left">
          <thead>
            <tr className="bg-bone border-b border-line">
              {["Article", "Source", "Type", "Claim supported", "Last verified", "Notes"].map((h) => (
                <th key={h} className="px-4 py-3 text-[9.5px] tracking-[0.16em] uppercase text-[#6E6A63] font-medium">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-b border-line/70" data-testid={`source-row-${i}`}>
                <td className="px-4 py-3.5 text-[13px] text-charcoal max-w-[220px]">{r.article_title}</td>
                <td className="px-4 py-3.5 text-[13px] font-light text-[#5A5A5A] max-w-[260px]">{r.title}</td>
                <td className="px-4 py-3.5 text-[12px] font-light text-[#5A5A5A]">{r.source_type}</td>
                <td className="px-4 py-3.5 text-[12px] font-light text-[#5A5A5A] max-w-[240px]">
                  {r.claim_supported}
                </td>
                <td className="px-4 py-3.5">
                  {r.last_verified ? (
                    <Pill tone="green">{String(r.last_verified).slice(0, 10)}</Pill>
                  ) : (
                    <Pill tone="yellow">Not verified</Pill>
                  )}
                </td>
                <td className="px-4 py-3.5 text-[11.5px] font-light text-[#6E6A63] max-w-[300px]">{r.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bg-white border border-line px-6 md:px-8 py-7 mt-8">
        <div className="text-[10px] tracking-[0.2em] uppercase text-sage mb-4">
          Fields flagged for frequent reverification
        </div>
        <div className="flex flex-wrap gap-2">
          {[
            "price", "dimensions", "electrical requirements", "warranty", "product availability",
            "affiliate terms", "commission rates", "cookie windows", "manufacturer specifications",
          ].map((f) => (
            <span key={f} className="text-[11.5px] font-light px-3 py-1.5 bg-bone border border-line text-[#5A5A5A]">
              {f}
            </span>
          ))}
        </div>
      </div>
    </AdminPage>
  );
}
